import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "card";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    // 批量注册卡片;
    async inputCard({ commit }, payload) {
      let result = await api.post("/api/WeighingCardInfo/InputCard", payload);
      return result.data;
    },
    // 获取卡片管理数据
    async getcardListData({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingCardInfo?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 获取卡号
    async GetCardShowNumberByCardNumber({ commit }, payload) {
      let result = await api.get(
        `/api/WeighingCardInfo/GetCardShowNumberByCardNumber?${queryString.stringify(
          payload
        )}`
      );
      return result.data;
    },
  },
});

export default moduleName;
